export enum ServicePlanPermissions {
  GET_SERVICE_PLANS = 'servicePlans.getServicePlans',
  PERSIST_SERVICE_PLAN = 'servicePlans.persistServicePlan',
  INVITE_TO_SERVICE_PLAN = 'servicePlans.inviteToServicePlan',
  GET_SERVICE_PLAN_PERIODS = 'servicePlans.getServicePlanPeriods',
  ARRANGE_SERVICE_PLAN_PERIOD_COMMITMENT = 'servicePlans.arrangeServicePlanPeriodCommitment',
  PERSIST_DISCOUNT = 'servicePlans.persistDiscount',
}
